import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_INTERLOCK = "access-control-service/interlocks";

const RESOURCES = {
   LIST_INTERLOCKS_PAGINATED: (
      page,
      searchText,
      condominiumId,
      licenceId,
      orderBy,
   ) =>
      `${BASE_INTERLOCK}/condominiums/${condominiumId}/licences/${licenceId}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,

   CREATE_INTERLOCK: () => BASE_INTERLOCK,
   CREATE_BULK_INTERLOCKS: () => `${BASE_INTERLOCK}/bulk-by-ids`,
   DELETE_INTERLOCK: (interlockId) =>
      `${BASE_INTERLOCK}/${interlockId}`,
   UPDATE_INTERLOCK: (interlockId) =>
      `${BASE_INTERLOCK}/${interlockId}`,
   LIST_CONDOMINIUM_INTERLOCK: (condominiumId) =>
      `${BASE_INTERLOCK}/condominiums/${condominiumId}`,
   GET_ONE_UUID: (uuid) => `${BASE_INTERLOCK}/uuid/${uuid}`,
};

class InterlockService {
   static async listInterlocksPaginated(
      page,
      searchText,
      condominiumId,
      licenceId,
      orderBy,
      cancelToken,
   ) {
      try {
         const response = await axios.get(
            RESOURCES.LIST_INTERLOCKS_PAGINATED(
               page,
               searchText,
               condominiumId,
               licenceId,
               orderBy,
            ),
            {
               signal: cancelToken,
            }
         );
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar intertravamentos",
         });
         return error.response;
      }
   }

   static async listCondominiumInterlocks(condominiumId) {
      try {
         const response = await axios.get(
            RESOURCES.LIST_CONDOMINIUM_INTERLOCK(condominiumId),
         );
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao listar intertravamentos do condomínio",
         });
         return error.response;
      }
   }

   static async getOneUuid(uuid) {
      try {
         return await axios.get(RESOURCES.GET_ONE_UUID(uuid));
      } catch (error) {
         console.error(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao obter intertravamento de acesso",
         });
         return error.response;
      }
   }

   static async createInterlock(payload) {
      try {
         const response = await axios.post(
            RESOURCES.CREATE_INTERLOCK(),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Intertravamento cadastrado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao cadastrar intertravamento",
         });
         return error.response;
      }
   }

   static async createBulkInterlocks(payload) {
      try {
         const response = await axios.post(
            RESOURCES.CREATE_BULK_INTERLOCKS(),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Intertravamento cadastrado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao cadastrar intertravamento",
         });
         return error.response;
      }
   }

   static async updateInterlock(interlockId, payload) {
      try {
         const response = await axios.put(
            RESOURCES.UPDATE_INTERLOCK(interlockId),
            payload,
         );
         ResponseAlerts({
            response: response,
            successMessage: "Intertravamento editado com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao editar intertravamento",
         });
         return error.response;
      }
   }
   static async deleteInterlock(interlockId) {
      try {
         const response = await axios.delete(
            RESOURCES.DELETE_INTERLOCK(interlockId),
         );
         ResponseAlerts({
            response: response,
            successMessage: "Intertravamento excluído com sucesso",
         });
         return response;
      } catch (error) {
         console.log(error);
         ResponseAlerts({
            response: error.response,
            errorMessage: "Erro ao excluir intertravamento",
         });
         return error.response;
      }
   }
}
export default InterlockService;
